export const campo =
  "h-9 w-full rounded-md border border-zinc-200 bg-white px-3 text-sm text-zinc-900 placeholder:text-zinc-400 focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500 dark:border-border dark:bg-card dark:text-foreground";
export const rotulo = "mb-1 block text-xs font-medium text-zinc-600 dark:text-muted-foreground";
export const moldura = "rounded-xl border border-zinc-200 bg-white shadow-sm dark:border-border dark:bg-card";
